import { useEffect, useState } from "react";
import { addTransfer } from "./TransactionService";
import { getAllAccounts } from "../accounts/AccountService";

export default function TransferForm(){

  const [accounts,setAccounts]=useState([]);

  const [form,setForm]=useState({
    fromAccountId:"",
    toAccountId:"",
    amount:"",
    date:"",
    description:""
  });

  useEffect(()=>{ load(); },[]);

  const load = async ()=>{
    setAccounts(await getAllAccounts());
  };

  const submit = async (e)=>{
    e.preventDefault();
    await addTransfer(form);
    alert("Transfer successful");
  };

  return (
    <form onSubmit={submit}>
      <h3>Transfer</h3>

      <select onChange={e=>setForm({...form,fromAccountId:e.target.value})} required>
        <option value="">From Account</option>
        {accounts.map(a=><option key={a.id} value={a.id}>{a.accountName}</option>)}
      </select>

      <select onChange={e=>setForm({...form,toAccountId:e.target.value})} required>
        <option value="">To Account</option>
        {accounts.map(a=><option key={a.id} value={a.id}>{a.accountName}</option>)}
      </select>

      <input type="number" placeholder="Amount"
        onChange={e=>setForm({...form,amount:e.target.value})} required />

      <input type="date"
        onChange={e=>setForm({...form,date:e.target.value})} required />

      <textarea placeholder="Description"
        onChange={e=>setForm({...form,description:e.target.value})} />

      <button type="submit">Transfer</button>
    </form>
  );
}
